import { track } from '@vercel/analytics';
import { getEnvironmentData } from '../utils/environment.js';
import { trackTikTokEvent, trackPostHog } from '../utils/tracking.js';

export const trackAddPlayer = (playerId, playerName, teamId) => {
  const eventData = {
    player_id: playerId,
    player_name: playerName,
    team_id: teamId,
    ...getEnvironmentData()
  };

  track('add_player', eventData);
  
  const tiktokEvent = {
    contents: [
      {
        content_name: 'player_addition',
        content_type: 'product',
        content_id: playerId
      }
    ]
  };
  trackTikTokEvent('CustomizeProduct', tiktokEvent);

  trackPostHog('player_added', eventData);
};

export const trackRemovePlayer = (playerId, playerName, teamId) => {
  const eventData = {
    player_id: playerId,
    player_name: playerName,
    team_id: teamId,
    ...getEnvironmentData()
  };

  track('remove_player', eventData);
  
  const tiktokEvent = {
    contents: [
      {
        content_name: 'player_removal',
        content_type: 'product',
        content_id: playerId
      }
    ]
  };
  trackTikTokEvent('RemoveFromCart', tiktokEvent);

  trackPostHog('player_removed', eventData);
};

export const trackEditPlayer = (playerId, changes) => {
  const eventData = {
    player_id: playerId,
    changes: changes,
    ...getEnvironmentData()
  };

  track('edit_player', eventData);
  
  const tiktokEvent = {
    contents: [
      {
        content_name: 'player_edit',
        content_type: 'product',
        content_id: playerId
      }
    ]
  };
  trackTikTokEvent('CustomizeProduct', tiktokEvent);

  trackPostHog('player_edited', eventData);
};

export const trackChangeGoalkeeper = (currentGoalkeeperName, newGoalkeeperName) => {
  const eventData = {
    current_goalkeeper: currentGoalkeeperName,
    new_goalkeeper: newGoalkeeperName,
    ...getEnvironmentData()
  };

  track('change_goalkeeper', eventData);
  
  trackTikTokEvent('CustomizeProduct', {
    content_name: 'change_goalkeeper',
    content_type: 'product',
    content_id: `${currentGoalkeeperName}_to_${newGoalkeeperName}`
  });

  trackPostHog('goalkeeper_changed', eventData);
}; 